import { createRoot } from "react-dom/client";
import { BaseLayout } from "./BaseLayout";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "auth/msalInstance";
import "assets/style.scss";
import "./utils/extensions";
import "./domain/Domain/Services/Validator";
import "./domain/Domain/Services/GroupConfigValidator";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
	<MsalProvider instance={msalInstance}>
		<BaseLayout />
	</MsalProvider>
);
